export class BrandSettings {
    advanceorderdays: number;

    public static Make(data: unknown): BrandSettings {
        return {
            advanceorderdays: (data as any).advanceorderdays || 60,
        };
    }
}
